// src/components/Landing/Landing.js (DEMO)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, Typography, CircularProgress } from '@mui/material';
import { keyframes } from '@mui/system';
import Navbar from '../Nav/Navbar';

import { startDemo } from '../../actions/access';
import {
  MainContainer,
  HeroContainer,
  Subheading,
  Heading,
  ButtonContainer,
} from './styles';

// Pulse animation for the circular wave
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  70% {
    transform: scale(1.9);
    opacity: 0;
  }
  100% {
    transform: scale(2.1);
    opacity: 0;
  }
`;

const Landing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [starting, setStarting] = useState(false);

  const handleStartDemo = async () => {
    if (starting) return; // block double-clicks

    setStarting(true);
    try {
      const result = await dispatch(startDemo());
      if (result?.ok) {
        navigate('/dashboard'); // or '/search'
      } else {
        console.error('Failed to start demo');
        setStarting(false); // allow retry if backend failed
      }
    } catch (err) {
      console.error('Error starting demo:', err);
      setStarting(false); // allow retry
    }
  };

  return (
    <MainContainer>
      <Navbar />
      {/* HERO SECTION */}
      <HeroContainer id="home">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Heading variant="h1" sx={{ fontSize: '24px' }}>
            MediCheck Live Demo
          </Heading>
          <Subheading sx={{ fontSize: '16px' }}>
            Explore the full app without creating an account.
          </Subheading>

          <ButtonContainer
            sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: 3 }}
          >
            {/* Circular play button with pulsing ring */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: 130,
                  height: 130,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {/* Pulsing ring */}
                <Box
  sx={{
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    border: '2px solid rgba(235, 33, 114, 0.4)',  // <-- updated
    animation: `${pulse} 2.2s ease-out infinite`,
    opacity: starting ? 0.6 : 1,
  }}
/>

                {/* Main circular button */}
                <Box
  component="button"
  onClick={handleStartDemo}
  disabled={starting}
  sx={{
    position: 'relative',
    width: 90,
    height: 90,
    borderRadius: '50%',
    border: 'none',
    cursor: starting ? 'default' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(#eb2172, #fda15f)',   // <-- your gradient
    color: '#fff',
    boxShadow: '0 12px 35px rgba(235, 33, 114, 0.25)', // <-- base
    transition:
      'transform 150ms ease, box-shadow 150ms ease, opacity 150ms ease',
    opacity: starting ? 0.8 : 1,
    '&:hover': !starting
      ? {
          transform: 'scale(1.05) translateY(-2px)',
          boxShadow: '0 16px 40px rgba(235, 33, 114, 0.45)', // <-- hover
        }
      : {},
    '&:active': !starting
      ? {
          transform: 'scale(0.97) translateY(0)',
          boxShadow: '0 8px 25px rgba(235, 33, 114, 0.5)',   // <-- active
        }
      : {},
    outline: 'none',
  }}
>
  {starting ? (
    <CircularProgress size={32} sx={{ color: '#fff' }} />
  ) : (
    <PlayArrowIcon fontSize="large" sx={{fontSize:'60px'}} />
  )}
</Box>
              </Box>
              {starting && (
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, mt: 1, textAlign: 'center' }}
              >
                Starting Demo...
              </Typography>
              )}
              {starting && (
                <Typography
                variant="subtitle1"
                sx={{ fontWeight: 400, textAlign: 'center' }}
              >
                This can take a few seconds while we set up sample data.
              </Typography>
              )}
              
            </Box>
          </ButtonContainer>
        </Box>
      </HeroContainer>
    </MainContainer>
  );
};

export default Landing;